"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = __importStar(require("react"));
function UndrawRightPlaces(p) {
  var primaryColor = p.primaryColor,
    height = p.height,
    style = p.style,
    props = __rest(p, ["primaryColor", "height", "style"]);
  var styleProps = __assign({
    width: '100%',
    height: height
  }, style);
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 561.548 636.423",
    style: styleProps
  }, props), React.createElement("path", {
    d: "M273.648 266.848h81.433a1 1 0 000-2h-81.433a1 1 0 000 2z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M311.164 171.67a7.744 7.744 0 00-3.486 10.224 7.429 7.429 0 00.634 1.052l-15.333 22.245 8.55 11.752 17.71-32.744a7.723 7.723 0 001.988-9.216 7.39 7.39 0 00-9.882-3.404q-.091.044-.181.091z",
    fill: "#ffb6b6"
  }), React.createElement("path", {
    d: "M220.205 176.154a13.373 13.373 0 00-3.888 19.86l19.032 24.277 42.14 31.149s29.677-25.927 29.915-33.986-2.938-9.766.238-8.059 6.067.427 4.977-.473-.705-1.001-.044-2.539 2.984-8.79 2.984-8.79l-11.572-9.447s-10.802 6.552-11.514 9.634 3.176 1.706-.711 3.08-9.636-2.634-5.032 1.717 4.459 6.446.645 6.773-9.836 10.945-9.836 10.945l-41.158-41.902a13.373 13.373 0 00-16.176-2.239z",
    fill: "#e6e6e6"
  }), React.createElement("path", {
    d: "M216.069 635.45H89.69a9.822 9.822 0 01-9.811-9.81V519.261a9.822 9.822 0 019.811-9.81h126.378a9.822 9.822 0 019.81 9.81v106.38a9.822 9.822 0 01-9.81 9.81z",
    fill: "#f2f2f2"
  }), React.createElement("path", {
    fill: "#ffb6b6",
    d: "M22.874 487.734l-.05 11.016 43.417 5.439.073-16.26-43.44-.195z"
  }), React.createElement("path", {
    d: "M27.99 484.882l1.015 18.403-7.882-.036-12.16 17.437A4.924 4.924 0 010 517.847l.1-21.904 7.814-3.74-7.79-1.51.037-8.258z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M385.453 258.123c-26.662-6.637-49.552-19.682-67.448-41.217a6.041 6.041 0 01-2.002-8.296l31.128-50.938a6.041 6.041 0 018.296-2.003l67.448 41.218a6.041 6.041 0 012.002 8.295L393.75 256.12a6.041 6.041 0 01-8.296 2.003z",
    fill: "#e6e6e6"
  }), React.createElement("path", {
    d: "M367.469 241.766c-14.038-1.532-28.628-12.752-43.362-26.498a5.658 5.658 0 01-1.875-7.769l26.752-43.777a5.658 5.658 0 017.77-1.876l60.019 36.678a5.658 5.658 0 011.875 7.77l-16.572 27.118a25.202 25.202 0 01-34.607 8.354z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M379.778 189.166l-20.765 34.192a2.4 2.4 0 11-4.103-2.492l20.765-34.192a2.4 2.4 0 114.103 2.492zM388.797 194.643l-20.765 34.192a2.4 2.4 0 01-4.103-2.491l20.765-34.193a2.4 2.4 0 014.103 2.492z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M248.38 303.95s-4.38 67.54-8 78c-3.93 11.32-3.42 28.5-9.32 44.95-1.82 5.08-3.68 10.23-5.54 15.34-.37 1.03-.75 2.06-1.12 3.09-2.43 6.65-4.86 13.19-7.18 19.37-.33.87-.66 1.73-.98 2.58-.01.02-.01.04-.02.05-7.66 20.15-14.22 36-16.84 38.62-2.8 2.8-21.72 3.96-45.1 4.28-43.33.58-101.99-1.71-101.99-1.71l.09-23.57s.52-.15 1.49-.44c1.79-.52 5.12-1.49 9.47-2.78 18.17-5.36 54.18-16.15 70.67-22.11 4.66-1.68 7.76-2.98 8.46-3.67 4.1-4 5.91 0 8.51 4 2.6 4 3.4 0 6.8-2.94s11.06 1.1 11.06 1.1l.18-6.9c.16-6.26.4-16 .64-25.75-.01-.01-.01-.01 0-.01.09-3.67.18-7.34.26-10.82.07-2.7.13-5.29.19-7.69.16-7.19.27-12.63.27-13.99 0-4.44 0-.99 3.51-3.67a15.673 15.673 0 001.49-1.33 17.32 17.32 0 002.06-2.2c.26-.56-1.35.2-3.44-.22a6.317 6.317 0 01-3.03-1.55c-4.41-3.97.35-16.15.35-16.15-10.02-20.04-9.3-36.48-4.61-49.14a63.007 63.007 0 0116.26-23.83 59.505 59.505 0 018.9-6.98l.31-1.65 3.39-18.33a38.512 38.512 0 0124.38-4.43 56.3 56.3 0 0117.99 5.83 66.77 66.77 0 0112.85 8.44z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    fill: "#ffb6b6",
    d: "M156.242 609.949l10.97 1.02 9.242-42.769-16.19-1.505-4.022 43.254z"
  }), React.createElement("path", {
    d: "M187.84 626.71l-16.3-13.65.73-7.85-3.79-.13-11.75-.38-2.88-.1-4.89 27.51 8.23.76 2.19-7.63 3.03 8.12 21.81 2.03a4.926 4.926 0 003.62-8.68zM217.22 464.7c-4.17 22.72-21.84 75.97-32.52 107.14-4.87 14.24-8.27 23.88-8.27 23.88l-5.55-1.75-9.36-2.96-3.42-1.08-4.14-1.31s.97-51.22.32-78.39c-.22-8.76-.6-15.02-1.23-16.26-2.6-5.1 1.75-5.64 6.34-6.93 4.6-1.29 1.01-3.23-.78-7.37-1.21-2.76 1.17-6.43 2.86-8.53a20.7 20.7 0 011.49-1.69s-11.7-3.98-24.93-8.47c-.01.01-.01 0-.01 0-1.33-.45-2.67-.9-4.01-1.36 4.66-1.68 7.76-2.98 8.46-3.67 4.1-4 5.91 0 8.51 4 2.6 4 3.4 0 6.8-2.94s11.06 1.1 11.06 1.1l.18-6.9c.16-6.26.4-16 .64-25.75-.01-.01-.01-.01 0-.01.09-3.67.18-7.34.26-10.82 7.05 5.4 13.89 10.7 20.09 15.6.01.01.03.02.03.04 14.91 11.78 26.1 21.24 27.67 24.24.71 1.36.47 4.97-.49 10.19z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M176.281 292.822c-4.688-1.43-9.617 3.398-9.474 8.297s4.055 9.047 8.561 10.974 75.945 13.958 81.231 11.24 9.128-9.238 6.793-14.705c-1.503-3.52-4.744-19.889-7.618-22.416-9.676-8.51-.797-19.608 5.178-31.025 5.285-10.098 16.679-17.822 16.565-29.218-.081-8.192-6.277-14.866-12.078-20.65l-18.445-18.388-17.51-17.456c-3.742-3.73-19.794-5.704-22.668-3.97-6.006 3.622-20.868 63.98-22.992 69.486-.682 1.768 3.75 24.388 5.556 24.96 4.992 15.817-3.786 18.87-13.328 32.437",
    fill: "#e6e6e6"
  }), React.createElement("path", {
    d: "M319.581 201.45a7.744 7.744 0 00-5.683 9.187 7.43 7.43 0 00.382 1.167l-19.917 18.255 5.707 13.365 24.58-27.956a7.723 7.723 0 004-8.539 7.39 7.39 0 00-8.872-5.527q-.099.023-.197.049z",
    fill: "#ffb6b6"
  }), React.createElement("path", {
    d: "M229.922 185.487a13.373 13.373 0 00-8.23 18.49l13.123 27.916 34.11 39.78s34.723-18.636 36.756-26.438-.68-10.175 2.034-7.801 5.818 1.773 4.957.651-.464-1.133.524-2.484 4.875-7.901 4.875-7.901l-9.168-11.795s-11.994 3.972-13.376 6.816 2.714 2.374-1.382 2.845-8.804-4.723-5.288.548 2.905 7.279-.886 6.745-12.034 8.47-12.034 8.47l-30.75-50.043a13.373 13.373 0 00-15.265-5.799z",
    fill: "#e6e6e6"
  }), React.createElement("circle", {
    cx: 218.482,
    cy: 128.054,
    r: 29.898,
    fill: "#ffb6b6"
  }), React.createElement("path", {
    d: "M195.38 105.95c.308-2.69 2.152-6.015 3.435-8.4s3.76-4.334 6.463-4.167a6.894 6.894 0 015.281 3.589 14.457 14.457 0 011.643 6.383 33.43 33.43 0 01-10.87 26.618c-2.096 1.879-4.617 3.551-7.431 3.615a9.585 9.585 0 01-6.789-3.053c-4.555-4.562-5.243-12.061-2.81-18.03s3.517-8.293 9.078-11.554",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M237.38 148.95c-.5 2.66 4.1 15.31 2.63 17.59 0 0-15.221 5.288-21.041 5.668-7.11.46-12.829-2.457-19.479-6.847a14.93 14.93 0 00-2.01-6.76 9.045 9.045 0 01-.94 4.62c-9.74-7.76-13.396-29.1-3.766-39.01l10-23c-3 1 6.056-14.45 15.606-3.26 11.95-12.17 35.1 5.35 38 21-2.79-3.533-4.244-3.116-4.96-.68a13.775 13.775 0 00-3.8-5.31 11.513 11.513 0 011.24 5.31c-18.85 1.17-15.342 13.887.109 32.937-5.714-3.557-1.858 11.77-4.91 15.433-.149-2.56-6.139-15.2-6.679-17.69z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M431.947 458.95h81.433a1 1 0 000-2h-81.433a1 1 0 000 2zM396.947 119.95h81.433a1 1 0 000-2h-81.433a1 1 0 000 2z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M460.547 102.478c-16.511-21.961-26.054-46.52-26.367-74.518a6.041 6.041 0 013.676-7.702L494.134.346a6.041 6.041 0 017.701 3.676l26.367 74.518a6.041 6.041 0 01-3.676 7.701l-56.278 19.913a6.041 6.041 0 01-7.701-3.676z",
    fill: "#e6e6e6"
  }), React.createElement("path", {
    d: "M456.9 78.443c-9.93-10.04-14.181-27.948-16.95-47.907a5.658 5.658 0 013.442-7.213L491.757 6.21a5.658 5.658 0 017.214 3.443l23.462 66.31a5.658 5.658 0 01-3.443 7.213L489.03 93.778a25.202 25.202 0 01-32.13-15.335z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M499.618 45.375l-37.676 13.448a2.4 2.4 0 01-1.613-4.521l37.675-13.448a2.4 2.4 0 011.614 4.52zM465.806 43.467l-8.289 2.96a2.4 2.4 0 11-1.614-4.522l8.29-2.959a2.4 2.4 0 011.613 4.521zM506.713 65.25L469.037 78.7a2.4 2.4 0 01-1.614-4.521L505.1 60.729a2.4 2.4 0 011.614 4.522zM503.165 55.313L465.49 68.76a2.4 2.4 0 01-1.614-4.521l37.675-13.448a2.4 2.4 0 111.614 4.52z",
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 437.38,
    cy: 25.951,
    r: 10,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M493.547 440.478c-16.511-21.961-26.054-46.52-26.367-74.518a6.041 6.041 0 013.676-7.702l56.278-19.912a6.041 6.041 0 017.701 3.676l26.367 74.518a6.041 6.041 0 01-3.676 7.701l-56.278 19.913a6.041 6.041 0 01-7.701-3.676z",
    fill: "#e6e6e6"
  }), React.createElement("path", {
    d: "M489.9 416.443c-9.93-10.04-14.181-27.948-16.95-47.907a5.658 5.658 0 013.442-7.213l48.365-17.113a5.658 5.658 0 017.214 3.443l23.462 66.31a5.658 5.658 0 01-3.443 7.213l-29.961 10.602a25.202 25.202 0 01-32.13-15.335z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M532.618 383.375l-37.676 13.448a2.4 2.4 0 01-1.613-4.521l37.675-13.448a2.4 2.4 0 011.614 4.52zM498.806 381.467l-8.289 2.96a2.4 2.4 0 01-1.614-4.522l8.29-2.959a2.4 2.4 0 111.613 4.521zM536.165 393.313L498.49 406.76a2.4 2.4 0 01-1.614-4.521l37.675-13.448a2.4 2.4 0 111.614 4.52z",
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 472.38,
    cy: 362.951,
    r: 10,
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 314.081,
    cy: 172.848,
    r: 10,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M210.178 124.458a1 1 0 01-.273-1.962c.262-.433.154-2.254.068-3.725-.325-5.524-.87-14.769 8.106-21.01a1 1 0 011.142 1.642c-8.055 5.601-7.572 13.815-7.251 19.25.182 3.108.315 5.353-1.57 5.78a.994.994 0 01-.222.025z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M14.261 635.233a1.186 1.186 0 001.19 1.19h253.29a1.19 1.19 0 000-2.38H15.451a1.187 1.187 0 00-1.19 1.19z",
    fill: "#ccc"
  }), React.createElement("path", {
    d: "M210.644 102.602a56.402 56.402 0 00-19.207-4.257c-5.237-.222-11.484.946-13.613 5.736-1.292 2.905-.604 6.311.578 9.263s2.839 5.742 3.523 8.847c1.474 6.69-2.004 13.779-7.343 18.072s-12.227 6.187-19.022 7.048c5.105 1.894 10.29 3.807 15.716 4.261s11.222-.725 15.274-4.364c4.385-3.937 6.07-10.053 6.816-15.899s.784-11.866 2.766-17.416 6.533-10.719 12.406-11.21",
    fill: "#2f2e41"
  }));
}
exports.default = UndrawRightPlaces;